import { render, staticRenderFns } from "./ConseilScientifique.vue?vue&type=template&id=240da20d&scoped=true"
import script from "./ConseilScientifique.vue?vue&type=script&lang=js"
export * from "./ConseilScientifique.vue?vue&type=script&lang=js"
import style0 from "./ConseilScientifique.vue?vue&type=style&index=0&id=240da20d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240da20d",
  null
  
)

export default component.exports